
import { LogEntry } from '@/api/dtos/LogEntry.schema'
import { logEntryToGerman } from '@/misc/i18n'
import moment from 'moment'
import { Component, Prop, Vue } from 'vue-property-decorator'
import AdminConfigLogEntryContent from './panelContent/AdminConfigLogEntryContent.vue'
import BookingLogEntryContent from './panelContent/BookingLogEntryContent.vue'
import DeviceConfigLogEntryContent from './panelContent/DeviceConfigLogEntryContent.vue'
import DeviceOpeningLogEntryContent from './panelContent/DeviceOpeningLogEntryContent.vue'
import ControllerLogEntryContent from './panelContent/ControllerLogEntryContent.vue'
import OperatorConfigLogEntryContent from './panelContent/OperatorConfigLogEntryContent.vue'
import StationConfigLogEntryContent from './panelContent/StationConfigLogEntryContent.vue'
import UpdateLogEntryContent from './panelContent/UpdateLogEntryContent.vue'
import UserConfigLogEntryContent from './panelContent/UserConfigLogEntryContent.vue'

@Component({
  components: {
    AdminConfigLogEntryContent,
    BookingLogEntryContent,
    DeviceConfigLogEntryContent,
    DeviceOpeningLogEntryContent,
    ControllerLogEntryContent,
    OperatorConfigLogEntryContent,
    StationConfigLogEntryContent,
    UpdateLogEntryContent,
    UserConfigLogEntryContent
  }
})
export default class LogEntryPanel extends Vue {
  @Prop()
  width!: string | number

  @Prop()
  height!: string | number

  @Prop()
  logEntry!: LogEntry

  logEntryToGerman = logEntryToGerman
  moment = moment

  get borderColor (): string {
    switch (this.logEntry.severity) {
      case 'INFO':
        return this.$vuetify.theme.currentTheme.bpbInfo as string
      case 'WARNING':
        return this.$vuetify.theme.currentTheme.bpbWarn as string
      case 'ALARM':
        return this.$vuetify.theme.currentTheme.bpbDanger as string
    }
  }
}
